import 'Utils/bootstrap.sass';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


import { createBrowserHistory } from 'history';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
// tslint:disable-next-line:import-name
import configureStore from './store/configure';
import InitialState from './store/InitialState';

import * as Router from './Routes';

const history = createBrowserHistory();
const store = configureStore(InitialState);

function renderApp() {
    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history} children={Router.routes} />
        </Provider>,
        document.getElementById('react-app')
    );
}

renderApp();
